import { Typography, Button, FormControl, FormGroup, InputLabel } from "@mui/material";
import humanFormat from "human-format";

import HeaderDivider from "../../../Lib/UI/Components/HeaderDivider";
import ConfirmPopup from "../../../Lib/UI/Components/ConfirmPopup";
import AsyncStatus from "../../../Lib/UI/Components/AsyncStatus";
import SettingDropDown from "./settingDropDown";
import { SettingsListProps, useSettingsList } from "../hooks/useSettingsList";


const SettingsList = (props: SettingsListProps): JSX.Element => {

    const list = useSettingsList(props);

    return (
        <>
            <HeaderDivider title="Interface" />

            <FormGroup>

                <FormControl>
                    <InputLabel size="normal">Optimisation</InputLabel>
                    <SettingDropDown 
                        options={props.service.toolbarFlowOrientationOptions} 
                        value={list.settings.ui.toolbarFlowOrientation} 
                        onChange={v => { list.settings.ui.toolbarFlowOrientation = v; props.service.setUI(list.settings.ui); }} 
                    />
                </FormControl>

                <FormControl>
                    <InputLabel size="normal">Heading Unit</InputLabel>
                    <SettingDropDown 
                        options={props.service.headingUnitOptions} 
                        value={list.settings.ui.headingUnit} 
                        onChange={v => { list.settings.ui.headingUnit = v; props.service.setUI(list.settings.ui); }} 
                    />
                </FormControl>

                <FormControl>
                    <InputLabel size="normal">Distance Units</InputLabel>
                    <SettingDropDown 
                        options={props.service.distanceUnitOptions} 
                        value={list.settings.ui.distanceUnits} 
                        onChange={v => { list.settings.ui.distanceUnits = v; props.service.setUI(list.settings.ui); }} 
                    />
                </FormControl>

            </FormGroup>


            <HeaderDivider title="Map" />

            <FormGroup>
                
                <FormControl> 
                    <InputLabel size="normal">Location Tracking Behaviour</InputLabel>
                    <SettingDropDown 
                        options={props.service.mapLocationTrackingBehaviourOptions} 
                        value={list.settings.map.locationTrackingBehaviour} 
                        onChange={v => { list.settings.map.locationTrackingBehaviour = v; props.service.setMap(list.settings.map); }}
                    />
                </FormControl>

                <FormControl>
                    <InputLabel size="normal">Default Layer</InputLabel>
                    <SettingDropDown 
                        options={props.service.config.tileLayers} 
                        value={list.settings.map.defaultLayerId} 
                        onChange={v => { list.settings.map.defaultLayerId = v; props.service.setMap(list.settings.map); }}
                    />
                </FormControl>

            </FormGroup>


            <HeaderDivider title="Downloads & Data" />
            
            <FormGroup>

                <FormControl> 
                    <InputLabel size="normal">Current Cache</InputLabel>
                    <AsyncStatus action={list.currentCacheInfoStatus} showChildrenWhenComplete={true} busyLabel="Calculating size...">
                    {list.cacheInfo &&
                        <>
                            <Typography>Storage used: <b>{humanFormat.bytes(list.cacheInfo.storageSizeBytes)}</b></Typography>
                            <Typography>Tile count: <b>{list.cacheInfo.numberOfTiles}</b></Typography>
                        </>
                    }
                    </AsyncStatus>
                </FormControl> 

                <FormControl> 
                    <Button variant="outlined" onClick={() => list.confirmClearTileCacheAction.start()}>Clear Tile Cache</Button>
                </FormControl>           

                <FormControl>
                    <InputLabel size="normal">Tile Cache Seed Method</InputLabel>
                    <SettingDropDown 
                        options={props.service.tileCacheSeederOptions} 
                        value={list.settings.tileCache.activeCacheSeederId} 
                        onChange={v => { list.settings.tileCache.activeCacheSeederId = v; props.service.setTileCache(list.settings.tileCache); }}
                    />
                </FormControl>

            </FormGroup>

            <ConfirmPopup 
                action={list.confirmClearTileCacheAction} 
                title="Clear Tile Cache" 
                text={["Clearing the tile cache will remove all locally downloaded map data.", "Are you sure you wish to clear the cache?"]}
                yesText="Yes, purge away!" 
                noText="No, let it stay"
                getWorkerPromise={list.getClearTileCachePromise}
            />
        </>
    );

}

export default SettingsList;